import styled from 'styled-components';

export const StepperElement = styled.div`
  position: relative;
  display: flex;
` as any;

export const StepsElement = styled.div`
  display: flex;
` as any;

export const StepElement = styled.div`
  color: ${(props: any) => getStepColor(props)};
  background-color: ${(props: any) => getStepBackgroundColor(props)};
  border: ${(props: any) => getStepBorder(props)};
  cursor: ${(props: any) => getStepCursor(props)};
  font-weight: 500;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 14px;
  height: 36px;
  width: 36px;
` as any;

export const StepWrapperElement = styled.div`
  margin-right: 50px;
  position: relative;
  &:before,
  &:after {
    content: '';
    width: 35px;
    border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.darkGS2};
    position: absolute;
    top: 50%;
  }

  &:after {
    left: 100%;
  }

  &:before {
    right: 100%;
  }

  &:first-of-type:before {
    display: none;
  }

  &:last-of-type:after {
    display: none;
  }

  &:last-of-type {
    margin-right: 0px;
  }
` as any;

function getStepColor({ theme, ticked, active }) {
  return ticked || active ? theme.vars.newColor.white : theme.vars.newColor.darkGS2;
}

function getStepBackgroundColor({ theme, ticked, active }) {
  return active ? theme.vars.newColor.blue2 : ticked ? theme.vars.newColor.darkGS2 : theme.vars.newColor.white;
}

function getStepBorder({ theme, ticked, active }) {
  return ticked || active ? '1px solid transparent' : '1px solid ' + theme.vars.newColor.darkGS2;
}

function getStepCursor({ selectable }) {
  return selectable ? 'pointer' : 'default';
}
